"use strict";

angular.module('rmAuth', []);

require('./controller');